if (!customElements.get('pickup-availability-fetch')) {
    customElements.define(
        'pickup-availability-fetch',
        class PickupAvailabilityFetch extends HTMLElement {
            constructor() {
                super();
                this.fetchAvailability();
            }

            fetchAvailability() {
                const variantsId = this.dataset.variantsId;
                const url = (this.dataset.url || '').replace('{variantsId}', variantsId || '');
                const options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };

                fetch(url, options)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status != 200) {
                            console.error('Error fetching pickup availability:', response);
                            return;
                        }
                        this.renderData(response.result.data.nodes);
                    })
                    .catch((err) => {
                        console.error('Error fetching pickup availability:', err);
                        const button = this.querySelector('button');
                        !!button && button.classList.add('hidden');
                    });

                return;
            }


            onClickRefreshList(evt) {
                this.fetchAvailability(this.dataset.variantId);
            }

            renderData(nodes) {
                const drawer = document.querySelector('pickup-availability-fetch-drawer') || this.querySelector('pickup-availability-fetch-drawer');
                const drawerContent = drawer.querySelector('[data-store-availability-drawer-content]')

                if (!!!drawerContent) {
                    console.error('No drawer content found');
                    return;
                }

                drawerContent.innerHTML = '';
                const items = nodes.map((node) => {
                    const inventoryLevelsContent = node.inventoryItem.inventoryLevels.edges.map((edge) => {
                        const disabledPickup = edge.node.location.disabledPickup ? edge.node.location.disabledPickup.value === 'true' : false;

                        if (disabledPickup) {
                            return '';
                        }

                        const name = `${edge.node.location.name}`
                        const address = `${edge.node.location.address.address1}` +
                            `${edge.node.location.address.city ? `, ${edge.node.location.address.city}` : ''}` +
                            `${edge.node.location.address.province ? `, ${edge.node.location.address.province}` : ''}`;
                        const quantity = edge.node.quantities[0].quantity;
                        const isAvailable = quantity > 0 ? true : false;

                        const mail = edge.node.location.mail ? edge.node.location.mail.value : '';
                        const phone = edge.node.location.phone ? edge.node.location.phone.value : edge.node.location.address.phone || '';
                        const mailContent = !!mail ? `
                            <div class="pickup-availability-address__item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                    <g>
                                        <rect data-name="Rectángulo 290" width="15" height="15" fill="#ffcc4c" opacity="0"/>
                                        <path data-name="Trazado 348" d="M12.625,4H3.875A1.875,1.875,0,0,0,2,5.875v6.25A1.875,1.875,0,0,0,3.875,14h8.75A1.875,1.875,0,0,0,14.5,12.125V5.875A1.875,1.875,0,0,0,12.625,4Zm-.419,1.25L8.25,8.219,4.294,5.25Zm.419,7.5H3.875a.625.625,0,0,1-.625-.625V6.031L7.875,9.5a.625.625,0,0,0,.75,0L13.25,6.031v6.094A.625.625,0,0,1,12.625,12.75Z" transform="translate(-0.75 -1.5)" fill="#ffcc4c"/>
                                    </g>
                                </svg>
                                <span>${mail}</span>
                            </div>
                        ` : '';
                        const phoneContent = !!phone ? `
                            <div class="pickup-availability-address__item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                    <g>
                                        <rect data-name="Rectángulo 302" width="15" height="15" fill="#ffcc4c" opacity="0"/>
                                        <path data-name="Trazado 360" d="M11.625,14.5A9.638,9.638,0,0,1,2,4.875,2.875,2.875,0,0,1,4.875,2a2.462,2.462,0,0,1,.481.044,2.369,2.369,0,0,1,.45.113.625.625,0,0,1,.406.469l.856,3.75a.625.625,0,0,1-.163.575c-.081.088-.088.094-.856.494A6.194,6.194,0,0,0,9.094,10.5c.406-.775.413-.781.5-.863a.625.625,0,0,1,.575-.162l3.75.856a.625.625,0,0,1,.45.406,2.712,2.712,0,0,1,.119.456,2.981,2.981,0,0,1,.038.475A2.875,2.875,0,0,1,11.625,14.5ZM4.875,3.25A1.631,1.631,0,0,0,3.25,4.875a8.381,8.381,0,0,0,8.375,8.375,1.631,1.631,0,0,0,1.625-1.625v-.206l-2.9-.669-.181.344c-.281.544-.488.938-1.012.725A7.406,7.406,0,0,1,4.669,7.312c-.225-.487.2-.713.738-.994L5.75,6.15l-.669-2.9Z" transform="translate(-0.75 -0.75)" fill="#ffcc4c"/>
                                    </g>
                                </svg>
                                <span>${phone}</span>
                            </div>
                        ` : '';

                        const addressContent = !!address ? `
                            <div class="pickup-availability-address__item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                <g>
                                    <rect data-name="Rectángulo 303" width="15" height="15" fill="#ffcc4c" opacity="0"/>
                                    <path data-name="Trazado 361" d="M9,2A5,5,0,0,0,4,6.95c0,3.425,4.406,7.237,4.594,7.4a.625.625,0,0,0,.813,0C9.625,14.188,14,10.375,14,6.95A5,5,0,0,0,9,2ZM9,13.031c-1.044-.994-3.75-3.75-3.75-6.081a3.75,3.75,0,0,1,7.5,0C12.75,9.262,10.044,12.038,9,13.031Z" transform="translate(-1.5 -0.75)" fill="#ffcc4c"/>
                                    <path data-name="Trazado 362" d="M10.688,6a2.188,2.188,0,1,0,2.188,2.188A2.187,2.187,0,0,0,10.688,6Zm0,3.125a.938.938,0,1,1,.938-.937A.938.938,0,0,1,10.688,9.125Z" transform="translate(-3.188 -2.25)" fill="#ffcc4c"/>
                                </g>
                                </svg>
                                <span>${address}</span>
                            </div>
                        ` : '';
                        return `
                            <div class="pickup-availability-list__item" data-location>
                                <h3 class="h4">${name}</h3>
                                <address class="pickup-availability-address">
                                    ${mailContent}
                                    ${phoneContent}
                                    ${addressContent}
                                </address>

                                <p class="pickup-availability-address__item pickup-availability__availability caption-large">
                                    <span class="pickup-availability__tick ${isAvailable ? 'pickup-availability__tick--available' : ''}"></span>
                                    <span class="pickup-availability__availability-wrapper-text">
                                        <span class="pickup-availability__availability-text">${isAvailable ? 'Disponible' : 'No Disponible'}</span>
                                        <span class="pickup-availability__availability-quantity ${isAvailable && quantity <= 5 ? '' : 'hidden'}">${ window.pickupAvailabilityFetch.remainingQuantity.replace('[quantity]', quantity) }</span>
                                    </span>
                                </p>
                            </div>
                        `
                    })

                    const li = document.createElement('li');
                    li.setAttribute('data-id', node.id);
                    if (!node.id.includes(this.dataset.selectedVariantId)) {
                        li.classList.add('hidden');
                    }
                    li.innerHTML = inventoryLevelsContent.join('');
                    return li.outerHTML;
                })

                drawerContent.innerHTML = items.join('');

                document.body.appendChild(drawer);

                const button = this.querySelector('button');
                !!button && button.addEventListener('click', (evt) => {
                    document.querySelector('pickup-availability-fetch-drawer').show(evt.target);
                });
            }
        }
    );
}

if (!customElements.get('pickup-availability-fetch-drawer')) {
    customElements.define(
        'pickup-availability-fetch-drawer',
        class PickupAvailabilityFetchDrawer extends HTMLElement {
            constructor() {
                super();

                this.onBodyClick = this.handleBodyClick.bind(this);

                this.querySelector('button').addEventListener('click', () => {
                    this.hide();
                });

                this.addEventListener('keyup', (event) => {
                    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
                });

                const searchForm = this.querySelector('[data-search-form]');
                !!searchForm && searchForm.addEventListener('submit', (evt) => {
                    evt.preventDefault();
                    const input = searchForm.querySelector('input');

                    if (!input) return;

                    const query = input.value.trim();

                    this.filterLocation(query);
                });
            }

            filterLocation(query) {
                const locations = this.querySelectorAll('[data-store-availability-drawer-content] li:not(.hidden) [data-location]');

                if (!locations || locations.length === 0) return;

                locations.forEach((location) => {
                    const name = location.querySelector('h3').textContent.toLowerCase();
                    const address = location.querySelector('.pickup-availability-address').textContent.toLowerCase();
                    const phone = location.querySelector('.pickup-availability-address__item span').textContent.toLowerCase();
                    const mail = location.querySelector('.pickup-availability-address__item span').textContent.toLowerCase();
                    if (query === '' || name.includes(query.toLowerCase()) || address.includes(query.toLowerCase()) || phone.includes(query.toLowerCase()) || mail.includes(query.toLowerCase())) {
                        location.classList.remove('hidden');
                    } else {
                        location.classList.add('hidden');
                    }
                });
            }

            handleBodyClick(evt) {
                const target = evt.target;
                if (
                    target != this &&
                    !target.closest('pickup-availability-fetch-drawer') &&
                    target.id != 'ShowPickupAvailabilityDrawer'
                ) {
                    this.hide();
                }
            }

            hide() {
                this.removeAttribute('open');
                document.body.removeEventListener('click', this.onBodyClick);
                document.body.classList.remove('overflow-hidden');
                removeTrapFocus(this.focusElement);
            }

            show(focusElement) {
                this.focusElement = focusElement;
                this.setAttribute('open', '');
                // document.body.addEventListener('click', this.onBodyClick);
                document.body.classList.add('overflow-hidden');
                trapFocus(this);
            }

            showItem(variantId) {
                const items = this.querySelectorAll('[data-store-availability-drawer-content] li');
                items.forEach((item) => {
                    if (item.dataset.id.includes(variantId)) {
                        item.classList.remove('hidden');
                    } else {
                        item.classList.add('hidden');
                    }
                });
            }
        }
    );
}
